// #356: the row that comes back with «More time», as a planned entry. Its
// sets are written as the program would write them (SetPrescription), then
// read through the session resolver's own planned sets, so a start and a
// «More time» row land on the same targets. Keep free of React and any UI
// import.
import { buildIntensity } from "./programEditBuild.js";
import type { MoreTimeItem } from "./programModelMoreTime.js";
import { buildPlannedSets } from "./programResolution.js";
import type { PlannedExerciseEntry } from "./schemas/plan.js";
import type { SetIntensity, SetPrescription } from "./schemas/program.js";

/** The planned entry of a «row» step; null for any other step. */
export const moreTimeRowEntry = (item: MoreTimeItem): PlannedExerciseEntry | null => {
  if (item.add !== "row" || !item.sets || item.sets.length === 0) return null;
  const sets: SetPrescription[] = item.sets.map((s) => {
    const kind = s.kind ?? item.axis ?? "none";
    // Model values are canonical kg; a value the cell cannot hold reads as none.
    const built = buildIntensity(kind, s.value === null ? "" : String(s.value), "kg");
    const intensity: SetIntensity = "error" in built ? { kind: "none" } : built;
    return {
      reps: item.timed ? 0 : s.reps,
      ...(item.timed ? { work: { kind: "countdown" as const, durationSec: s.reps } } : {}),
      ...(s.range && !s.amrap ? { repsMin: s.range.min, repsMax: s.range.max } : {}),
      ...(s.amrap ? { amrap: true } : {}),
      ...(s.amrap && s.amrapStop ? { amrapStop: { ...s.amrapStop } } : {}),
      intensity,
      ...(item.restSec !== undefined ? { restSec: item.restSec } : {}),
      ...(item.pause ? { pause: { ...item.pause } } : {}),
    };
  });
  // One round, not the test round of a cycle: no 1MAX on it.
  return { exerciseId: item.exerciseId, sets: buildPlannedSets({ weeks: [{ sets }] }, 0, 2, () => undefined) };
};
